import React from 'react'
import { Card, Typography, Row, Col, Input } from 'antd'
import PropTypes from 'prop-types'
import { Checkbox } from '~stories'
import styles from './AddToCalender.module.css'

const { Title } = Typography

const addToCalendar = ({ addToCalendar, setAddToCalendar }) => {
  return (
    <div className={styles['add-to-calender-container']}>
      <Title className={styles['title-text']} level={2}>Add To Calendar</Title>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Title level={3}>Url*</Title>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              onChange={(e) => setAddToCalendar({ ...addToCalendar, url: e.target.value })}
              value={addToCalendar?.url || ''}
            />
          </Col>
        </Row>
        {/* {addToCalendar && !addToCalendar.url && <Paragraph className={styles['paragraph-text']}>Please fill out this field</Paragraph>} */}
        <br />
        <Row>
          <Col span={24}>
            <Checkbox
              checked={addToCalendar?.show_link}
              label={<Title level={3}>Show Link</Title>}
              onChange={(e) => setAddToCalendar({ ...addToCalendar, show_link: e.target.checked })}
            />
          </Col>
        </Row>
      </Card>
    </div>
  )
}

addToCalendar.propTypes = {
  addToCalender: PropTypes.object,
  setAddToCalender: PropTypes.func
}

export default addToCalendar
